
import React from 'react';
import { publicUrl } from '@/Helpers/general';
import {Link} from "react-router-dom";

const Footer = () => {
    return (
        <div className="footer-links-wrap">
            <ul className="footer-links">
                <li>
                    <Link className="text-highlight" to={publicUrl('terms-of-use')}>Terms of Use</Link>
                </li>
                <li>
                    <Link className="text-highlight" to={publicUrl('about-us')}>About Us</Link>
                </li>
                <li>
                    <Link className="text-highlight" to={publicUrl('cookies')}>Cookies</Link>
                </li>
                <li>
                    <Link className="text-highlight" to={publicUrl('privacy-policy')}>Privacy Policy</Link>
                </li>
            </ul>
        </div>
    );
};

export default Footer;
